<template>
  <zj-layout-container>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable" style="height:100%;">
      <el-tabs class="zj-user-org-tabs" v-model="OgrVal" tab-position="left" height="100%">
        <el-tab-pane
          :key="item.id"
          v-for="(item) in  OrgOptions"
          :label="item.name"
          :name="item.id"
        >
          <UserListControl
            @loading="showLoading"
            @loadingFinish="hideLoading"
            :ref="item.id"
            :ResourceTypeId="ResourceTypeId"
            :PersonOrgianiztionId="item.id"
            v-bind="$attrs"
          ></UserListControl>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import { list } from "@/api/src/emergency_organization";

import UserListControl from "./UserListControl";
export default {
  name: "ZjUserOrgControl",
  controller: "UI",
  action: "UserOrgControl",
  components: {
    UserListControl
  },
  props: {
    editable: { type: Boolean, default: false },
    ResourceTypeId: { type: String },
  },
  data() {
    return {
      ruleForm: {},
      OrgOptions: [],
      OgrVal: ""
    };
  },
  created: function() {
    this.showLoading('加载中...');
    list({
        organizationType:this.$props.ResourceTypeId,
        size: 999,
        current: 1,
      })
      .then(r => {
        var data = r.data.records;
        if (data && data.length > 0) {
          this.OrgOptions = data;
          this.OgrVal = this.OrgOptions[0].id;
        }
        this.hideLoading();
      })
      .catch(e => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetUserIds() {
      var userids = [];
      for (var i = 0; i < this.OrgOptions.length; i++) {
        var item = this.OrgOptions[i];
        var chil = this.$refs[item.id][0];
        var usids = chil.Usersids;
        for (var j = 0; j < usids.length; j++) {
          userids.push(usids[j]);
        }
      }
      return userids;
    },
    GetCheckedUserItems() {
      var result = [];
      for (var i = 0; i < this.OrgOptions.length; i++) {
        var item = this.OrgOptions[i];
        var chil = this.$refs[item.id][0];
        var checkedUserItems = chil.CheckedUserItems;
        result = result.concat(checkedUserItems);
      }
      return result;
    },

  }
};
</script>